export default "__VITE_ASSET__BLIBcRrV__"